.create-choice-wrapper {
    display: flex;
    align-items: center;
}

/* Set margin after textfield before checkmark button */
.create-choice-wrapper > :first-child {
    margin-right: 8px;
}
